"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _PricingCards = _interopRequireDefault(require("../PricingCards/PricingCards"));
var _ImageGallery = _interopRequireDefault(require("../ImageGallery/ImageGallery"));
var _QuantityTracker = _interopRequireDefault(require("../../components/QuantityTracker/QuantityTracker"));
require("./ProductDetail.scss");
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
var _LoadingSpinner = _interopRequireDefault(require("../../components/LoadingSpinner/LoadingSpinner"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ButtonSpinner = _ref => {
  let {
    text
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "product-detail-page__processing"
  }, /*#__PURE__*/_react.default.createElement(_LoadingSpinner.default, {
    size: "20px",
    width: "2px",
    color: "white"
  }), " ", text);
};
const ProductDetail = _ref2 => {
  let {
    content,
    selected,
    setSelected,
    handleDecreaseQuantity,
    handleIncreaseQuantity,
    handleChangeQuantity,
    count,
    error,
    errorMessage,
    isLoading = false,
    isProcessing = false,
    disableBtn = false
  } = _ref2;
  const {
    eyebrow,
    productName,
    subheader,
    imageGalleryContent,
    labels,
    pricingDetails,
    counter,
    finePrint,
    needHelpPurchasing,
    bulkPurchase,
    productDetailList,
    Link,
    comparePlansLink,
    startTrialLink,
    addToCartButton
  } = content;
  const isDisabled = error || !selected || isLoading || isProcessing || disableBtn;
  const {
    processingText: processingLabel = 'Processing',
    text: addToCartLabel = 'Add to Cart'
  } = addToCartButton;
  const buttonContent = isProcessing ? /*#__PURE__*/_react.default.createElement(ButtonSpinner, {
    text: processingLabel
  }) : isLoading ? /*#__PURE__*/_react.default.createElement(ButtonSpinner, {
    text: addToCartLabel
  }) : addToCartLabel;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "product-detail-page"
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, imageGalleryContent && imageGalleryContent?.images?.length && /*#__PURE__*/_react.default.createElement("section", {
    className: "product-detail-page__image-gallery"
  }, /*#__PURE__*/_react.default.createElement(_ImageGallery.default, {
    content: imageGalleryContent,
    type: "product",
    sliderQty: 3
  })), /*#__PURE__*/_react.default.createElement("section", {
    className: !imageGalleryContent?.images?.length ? "product-detail-page__product-information-no-image-gallery" : "product-detail-page__product-information"
  }, /*#__PURE__*/_react.default.createElement("div", null, eyebrow && /*#__PURE__*/_react.default.createElement("h2", {
    className: !imageGalleryContent?.images?.length ? "product-detail-page__eyebrow product-detail-page__product-information-no-image-gallery--eyebrow" : "product-detail-page__eyebrow product-detail-page__product-information--eyebrow"
  }, eyebrow), productName && /*#__PURE__*/_react.default.createElement("h3", {
    className: !imageGalleryContent?.images?.length ? "product-detail-page__product-name product-detail-page__product-information-no-image-gallery--product-name" : "product-detail-page__product-name product-detail-page__product-information--product-name"
  }, productName), subheader && /*#__PURE__*/_react.default.createElement("p", {
    className: !imageGalleryContent?.images?.length ? "product-detail-page__subheader product-detail-page__product-information-no-image-gallery--subheader" : "product-detail-page__subheader product-detail-page__product-information--subheader"
  }, subheader), /*#__PURE__*/_react.default.createElement("div", {
    className: !imageGalleryContent?.images?.length ? "product-detail-page__product-detail-list product-detail-page__product-information-no-image-gallery--product-detail-list" : "product-detail-page__product-detail-list product-detail-page__product-information--product-detail-list",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(productDetailList)
  })), /*#__PURE__*/_react.default.createElement("div", null, labels?.chooseYourPlanLabel && /*#__PURE__*/_react.default.createElement("p", {
    className: !imageGalleryContent?.images?.length ? "product-detail-page__choose-your-plan-label  product-detail-page__product-information-no-image-gallery--choose-your-plan-label" : "product-detail-page__choose-your-plan-label product-detail-page__product-information--choose-your-plan-label"
  }, labels?.chooseYourPlanLabel || "Choose Your Plan"), /*#__PURE__*/_react.default.createElement("section", {
    className: !imageGalleryContent?.images?.length ? "product-detail-page__product-information-no-image-gallery--compare-trial" : "product-detail-page__product-information--compare-trial"
  }, comparePlansLink && /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    contentfulId: comparePlansLink?.contentfulId,
    to: comparePlansLink?.url,
    Link: Link
  }, comparePlansLink.text), startTrialLink && /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    contentfulId: startTrialLink?.contentfulId,
    to: startTrialLink?.url,
    Link: Link
  }, startTrialLink.text)), pricingDetails?.cards && pricingDetails?.cards?.length && /*#__PURE__*/_react.default.createElement("div", {
    className: !imageGalleryContent?.images?.length ? "product-detail-page__product-information-no-image-gallery--card" : "product-detail-page__product-information--card"
  }, /*#__PURE__*/_react.default.createElement(_PricingCards.default, {
    content: pricingDetails,
    contentfulId: pricingDetails?.contentfulId,
    selected: selected,
    setSelected: setSelected
  })), labels?.numberOfLicensesLabel && /*#__PURE__*/_react.default.createElement("p", {
    className: !imageGalleryContent?.images?.length ? "product-detail-page__choose-your-plan-number-label  product-detail-page__product-information-no-image-gallery--choose-your-plan-number-label" : "product-detail-page__choose-your-plan-number-label product-detail-page__product-information--choose-your-plan-number-label"
  }, labels?.numberOfLicensesLabel || "Choose the Number of Licenses"), /*#__PURE__*/_react.default.createElement("div", {
    className: !imageGalleryContent?.images?.length ? "product-detail-page__product-information-no-image-gallery--add-to-cart" : "product-detail-page__product-information--add-to-cart"
  }, /*#__PURE__*/_react.default.createElement(_QuantityTracker.default, {
    size: "large",
    labelPosition: "left",
    min: 0,
    quantityCount: count,
    handleDecreaseQuantity: handleDecreaseQuantity,
    handleIncreaseQuantity: handleIncreaseQuantity,
    handleChangeQuantity: handleChangeQuantity,
    errorMessage: errorMessage && error ? errorMessage : null,
    error: error
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: isDisabled ? `ter-button ter-button--primary--1 product-detail-page__product-information--add-to-cart__button disabled` : `ter-button ter-button--primary--1 product-detail-page__product-information--add-to-cart__button`,
    text: buttonContent,
    disabled: isDisabled,
    onClick: addToCartButton?.onClick
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "product-detail-page__product-information--small-print-details-with-links"
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, bulkPurchase?.text && /*#__PURE__*/_react.default.createElement("p", {
    className: "product-detail-page__product-information--small-print-details-with-links--text"
  }, bulkPurchase?.text), bulkPurchase?.link?.url && bulkPurchase?.link?.text && /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    contentfulId: bulkPurchase?.contentfulId,
    to: bulkPurchase?.link?.url,
    Link: Link
  }, bulkPurchase?.link?.text)), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, needHelpPurchasing?.text && /*#__PURE__*/_react.default.createElement("p", {
    className: "product-detail-page__product-information--small-print-details-with-links--text"
  }, needHelpPurchasing?.text), needHelpPurchasing?.link?.url && needHelpPurchasing?.link?.text && /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    contentfulId: needHelpPurchasing?.contentfulId,
    to: needHelpPurchasing?.link?.url,
    Link: Link
  }, needHelpPurchasing?.link?.text)))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "product-detail-page__fine-print-section"
  }, finePrint && finePrint?.length && finePrint.map((print, i) => {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "product-detail-page__fine-print",
      key: i
    }, print);
  })));
};
var _default = ProductDetail;
exports.default = _default;